document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gallery-progress-bar]').forEach(function (bar) {
    var nav = bar.previousElementSibling;

    if (!nav || !nav.getAttribute) {
      return;
    }

    var carouselId = nav.getAttribute('aria-controls');
    var carousel = carouselId ? document.getElementById(carouselId) : null;
    var fill = bar.querySelector('[data-gallery-progress-bar-fill]');

    if (!carousel || !fill) {
      return;
    }

    function updateFromScroll() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;

      // The thumb's width reflects how much of the gallery is visible at once (so more photos means a
      // shorter thumb), and it slides along the track with scroll position, like a native scrollbar thumb
      // — the portion behind it returns to the plain track colour instead of staying filled.
      var thumbWidth = maxScroll > 0 ? (carousel.clientWidth / carousel.scrollWidth) * 100 : 100;
      thumbWidth = Math.max(8, Math.min(100, thumbWidth));

      var scrollPercent = maxScroll > 0 ? carousel.scrollLeft / maxScroll : 0;
      var left = scrollPercent * (100 - thumbWidth);

      fill.style.width = thumbWidth + '%';
      fill.style.left = left + '%';
    }

    carousel.addEventListener('scroll', updateFromScroll, { passive: true });
    updateFromScroll();
  });
});
